'use strict';
export const Constants = Object.freeze({
  FILE_LINKS: [
    {
      name: 'BUYERENTRY',
      templatePath: '/assets/templates/buyerEntryLinks.csv',
      key: 'buyer_entry_link',
      downloadFileName: 'buyerEntryLinks.csv',
    },
  ],
  NC_SECURITY_OPTIONS: [
    {
      label: 'off',
      value: 0,
    },
    {
      label: 'SHA-256',
      value: 1,
    },
    {
      label: 'DECIPHER',
      value: 2,
    },
  ],
  NC_ENTRY_LINK: {
    REGEX:
      '^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?(\\?[a-z_-\\d]+=[\\[\\]a-zA-Z\\d%_.~+-]+)?(&[a-z_-\\d]+=[\\[\\]a-zA-Z\\d%_.~+-]+)*',
    KEY: '[%%buyer_transaction_id%%]',
  },
  FEOT_INFO: {
    DEFAULT_QUANTITY: 200,
    DEFAULT_REMAINING_TIME: 5,
  },
});
